  import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
  import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
  import { PipelineGradeDto } from '@cradua/data';
  import Swal from 'sweetalert2';
  
  
  @Component({
    selector: 'cradua-pipelinegrade',
    templateUrl: './pipelinegrade.component.html',
    styleUrls: ['./pipelinegrade.component.scss']
  })
  export class PipelinegradeComponent implements OnInit {
  
  
    pipelinegradeForm: FormGroup;
    pipelinegradeFormArray: FormGroup;
    control = new FormControl();
    @Input() pipelinegrades: PipelineGradeDto[];
    @Input() routeAnimationsElements: any;
    @Output() pipelinegrade = new EventEmitter<PipelineGradeDto[]>()
    @Output() deletePipelineGradeEvent = new EventEmitter<any>()
  
      selectedPipelinegrade: any;
      filteredDelete: Array<any> =[];
      loading = true;
      selectedIndex = null;
      constructor(
       private fb: FormBuilder,
       ) {}
  
      ngOnInit() {
        this.createPipelinegradeForm();
      }
  
      createPipelinegradeForm() {
        this.pipelinegradeForm = this.fb.group({
          PipelineGradeName: ['', Validators.required],
          id: null
          });
          this.pipelinegradeFormArray = this.fb.group({ Pipelinegrades: this.fb.array([])
            });
          this.setPipelinegrade();
      }
  
    // method to display pipelinegrades
    setPipelinegrade() {
      const control  = this.pipelinegradeFormArray.controls.Pipelinegrades as FormArray;
      this.pipelinegrades.forEach( e => {
        control.push(
          this.fb.group({
            PipelineGradeName: e.PipelineGradeName,
            id: e.id
          })
        );
      });
    }
  
  
    // method to add Pipelinegrade
    addPipelinegrade(value: PipelineGradeDto) {
      const control  = this.pipelinegradeFormArray.controls.Pipelinegrades as FormArray;
      control.insert(0,
            this.fb.group({
              PipelineGradeName: value.PipelineGradeName,
              id: null
            })
         );
    }
  
    selectPipelinegrade(value) {}
  
    // method to delete pipelinegrade from arrary list
    deletePipelinegrade(index, value) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then((result) => {
        if (result.value) {
    const control = this.pipelinegradeFormArray.controls.Pipelinegrades as FormArray;
    control.removeAt(index);
    for ( let i = 0; i < this.pipelinegrades.length; i++) {
        if (i === index) {
          if (value.id !== null) {
            this.filteredDelete.push(this.pipelinegrades[i].id);
           }
  
        }
      }
    Swal.fire(
            'Deleted!',
            'Your imaginary file has been deleted.',
            'success'
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              'Cancelled',
              'Your imaginary file is safe :)',
              'error'
            );
          }
        });
    }
  
    addNew(formValue: PipelineGradeDto) {
      if(this.pipelinegradeForm.invalid) {
     return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
      }
      if(this.selectedIndex != null) {
  
        this.pipelinegradeFormArray.get('Pipelinegrades')['controls'][this.selectedIndex].patchValue({PipelineGradeName: formValue.PipelineGradeName});
      } else {
        this.addPipelinegrade(formValue);
      }
      this.selectedIndex = null;
      this.pipelinegradeForm.reset()
    }
  
    onEdit(index, value: PipelineGradeDto) {
      console.log(index, value)
      this.selectedIndex = index;
      this.pipelinegradeForm.patchValue({PipelineGradeName: value.PipelineGradeName});
    }
  
    onClearForm() {
      this.selectedIndex = null;
      this.pipelinegradeForm.reset();
    }
  
    onSubmit(formValue: PipelineGradeDto[]) {
    this.pipelinegrade.emit(formValue);
    if(this.filteredDelete.length !== 0) {
      this.deletePipelineGradeEvent.emit(this.filteredDelete);
    }
    }
  
  }
  